export default function shallowCompareObjectEntries(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every(function (k) {
    return a[k] === b[k];
  });
}